export const EVENT_TYPE_CATEGORIES = {
    flowmeter: ['CF', 'IFR'],
    energymeter: ['ACTIVE_ENERGY'],
    temperature: ['TEMPERATURE'],
    volume: ['VOLUME'],
    comp: ['COMP'],
    agz: ['AGZ'],
    dg: ['DG'],
    grid: ['GRID'],
    motor: ['MOTOR'],
};

const EVENT_TYPE_TO_CATEGORY = Object.entries(EVENT_TYPE_CATEGORIES).reduce(
    (map, [category, eventTypes]) => {
        eventTypes.forEach(eventType => {
            map[eventType] = category;
        });
        return map;
    },
    {}
);

export const getEventCategory = (eventType) => {
    if (!eventType) return null;
    return EVENT_TYPE_TO_CATEGORY[eventType.toUpperCase()] || null;
};
